import type { CSSProperties } from "react"

/**
 * The underline bar's fill can be overridden via the `--underline-bar-color`
 * CSS variable (used by the underline-color picker to show a colored bar over a
 * neutral "U"). It defaults to `currentColor`, so the icon is single-tone unless
 * that variable is set.
 */
export default function IconTextUnderline({
  className,
  style,
}: {
  className?: string
  style?: CSSProperties
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      style={style}
    >
      {/* The "U" bowl. */}
      <path
        d="M5.58587 1.04943C5.13597 1.17933 4.68101 1.56987 4.45353 2.02147C4.26439 2.39723 4.2585 2.605 4.27724 8.29784C4.29659 14.161 4.28926 13.9692 4.54041 15.1906C4.66803 15.8113 5.01351 16.8559 5.30985 17.5168C6.38848 19.9224 8.28533 21.9136 10.6576 23.1303C12.3749 24.0111 14.0457 24.412 16 24.412C17.9206 24.412 19.4616 24.0525 21.1828 23.2025C22.4477 22.5779 23.4586 21.8441 24.4083 20.8612C26.1905 19.0166 27.2274 16.8834 27.6311 14.2316C27.6945 13.8148 27.7069 13.0112 27.7228 8.29881C27.7354 4.53694 27.7258 2.74968 27.6918 2.53038C27.5054 1.32966 26.2495 0.650588 25.159 1.16082C24.7919 1.33266 24.4598 1.65904 24.2803 2.02447L24.151 2.28788L24.1246 7.85887C24.0957 13.9332 24.1047 13.724 23.8271 14.759C23.2831 16.7868 22.0203 18.4947 20.2461 19.6021C19.3998 20.1303 18.26 20.5467 17.1873 20.7193C16.6822 20.8006 15.3178 20.8006 14.8127 20.7193C13.0447 20.4347 11.5253 19.666 10.2907 18.4314C9.05068 17.1914 8.31826 15.7633 7.995 13.955C7.90476 13.4499 7.90019 13.2168 7.87508 7.85887L7.849 2.28788L7.7197 2.02447C7.53921 1.657 7.20838 1.33278 6.83622 1.15854C6.58543 1.04125 6.46142 1.01241 6.16148 1.00208C5.95347 0.99487 5.70376 1.01542 5.58587 1.04943Z"
        fill="currentColor"
      />
      {/* The underline bar. */}
      <path
        d="M2.27801 27.4898C1.77595 27.6493 1.36918 28.0025 1.14194 28.4761C1.01144 28.7479 0.999419 28.8115 1.00002 29.2296C1.00062 29.6324 1.01576 29.719 1.12884 29.9647C1.29323 30.3222 1.68474 30.7126 2.04969 30.8827L2.32367 31.0104H16H29.6763L29.9503 30.8827C30.3153 30.7126 30.7068 30.3222 30.8712 29.9647C30.9842 29.719 30.9994 29.6324 31 29.2296C31.0006 28.8115 30.9886 28.7479 30.8581 28.4761C30.6767 28.0981 30.3512 27.7725 29.9731 27.5912L29.6763 27.4487L16.0685 27.4401C5.16553 27.4333 2.42437 27.4431 2.27801 27.4898Z"
        style={{ fill: "var(--underline-bar-color, currentColor)" }}
      />
    </svg>
  )
}
